import React from 'react'

import PropTypes from 'prop-types'

import { Box } from 'app/components/design-system-components'
import { getRentalProfileItems, getSnugProfileItems } from 'app/sm/helpers'
import ProfileItemsContainer from 'app/sm/rental_reputation/components/profile_items_container'

class RentalReputation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.fetchCompleteness()
  }

  render() {
    const { completeness, error } = this.props
    const rentalProfileItems = getSnugProfileItems().concat(
      getRentalProfileItems(),
    )

    return (
      <div className="rental-reputation-container">
        <div className="">
          <div className="content row">
            <Box className="col-xs-12" mt={8}>
              <ul className="references">
                <ProfileItemsContainer
                  title="Application Items"
                  message="Items for including on Rental applications."
                  completeness={completeness}
                  profileItems={rentalProfileItems}
                />
              </ul>
            </Box>
          </div>

          {error && (
            <div className="row">
              <div className="col-sm-12">
                <div className="alert alert-danger">
                  <div>{error}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

RentalReputation.propTypes = {
  fetchCompleteness: PropTypes.func.isRequired,
  completeness: PropTypes.object.isRequired,
  error: PropTypes.string,
}

RentalReputation.defaultProps = {
  error: '',
}

export default RentalReputation
